"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.MdeToolbarIcon = (function (_a) {
    var icon = _a.icon;
    return React.createElement("i", { className: "fas fa-" + icon, "aria-hidden": "true" });
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mde/lib/js/components/MdeToolbarIcon.js
// module id = 1371
// module chunks = 0